import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { KIDefinitionService } from '../../../../services/kidefinition.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { FormulaWorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-embed-settings',
    templateUrl: './embed.settings.html'
})
export class EmbedSettings extends FormulaWorkflowDialogContent {
    Data = new EmbedSettingsData();
    KIDefinitions: any[] = [];
    AvailableModels: string[] = [];

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'embedWFModule';
        reg.Caption = '@@KI: Embeddings erzeugen';
        reg.GroupID = 'aioperations';
        reg.Index = 101;
        reg.SettingsControl = EmbedSettings;
        reg.SettingsTypeHelper = new EmbedSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: KIDefinitionService) {
        super();
    }

    ngOnInit() {
        this.service.GetKIDefinitions('Embedding').subscribe(list => {
            this.KIDefinitions = list || [];
            if (this.Data.KIDefinition) {
                this.loadModels(this.Data.KIDefinition);
            }
        });
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, EmbedSettingsData);
        }
    }

    onKIDefinitionChange() {
        this.Data.Model = '';
        this.AvailableModels = [];
        if (this.Data.KIDefinition) {
            this.loadModels(this.Data.KIDefinition);
        }
    }

    private loadModels(id: string) {
        this.service.LoadKIDefinition(id).subscribe(def => {
            const all = def?.Models || [];
            const filtered = all.filter(m => (m.Capabilities & 2) !== 0);
            this.AvailableModels = (filtered.length > 0 ? filtered : all).map(m => m.Name);
        });
    }

    addInput() {
        if (!this.Data.Inputs) this.Data.Inputs = [];
        this.Data.Inputs.push('');
    }

    removeInput(idx: number) {
        this.Data.Inputs.splice(idx, 1);
    }

    trackByIndex(idx: number) { return idx; }

    getResult() {
        return this.Data;
    }
}

export class EmbedSettingsData {
    KIDefinition: string;
    Model: string = '';
    Inputs: string[] = [];
}

export class EmbedSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new EmbedSettingsData();
    }
}
